module.exports = __webpack_public_path__ + "assets/gmail.7c0bb7c7.svg";